import React from "react";

const FeeStructure = () => {
  return <div>Fee Structure</div>;
};

export default FeeStructure;
